import React from 'react'
import COLOR from '../../global/Color'
import {
  Page, VendorHero, Main, Section, Eyebrow, SectionTitle, SubTitle,
  Lead, BodyText, CardRow, ImageCard, VendorCta,
} from '../../components/inner/venderProduct/vendorUi'

import Portron1 from '../../assets/technologies/Portron1.jpg'
import Portron2 from '../../assets/technologies/Portron2.jpg'
import Portron3 from '../../assets/technologies/Portron3.jpg'
import Potron01 from '../../assets/technologies/PotronImage01.png'
import Potron02 from '../../assets/technologies/PotronImage02.png'
import Potron03 from '../../assets/technologies/PotronImage03.png'

const Potron = () => {
  return (
    <Page>
      <VendorHero
        title="Potron"
        subtitle="고속 광 트랜시버 · 부품 연구개발/제조 전문, 중국 심천 소재 (2017년 설립)"
      />

      <Main>
        {/* 회사 소개 */}
        <Section>
          <Eyebrow>Company</Eyebrow>
          <SectionTitle>회사 소개</SectionTitle>
          <Lead>
            Potron Technology Co., Ltd.{' '}
            <a href="https://www.potrontec.com" target="_blank" rel="noreferrer" style={{ color: COLOR.BLUE }}>
              (https://www.potrontec.com)
            </a>
            는 2017년 8월에 설립되어 중국 심천에 본사를 두고 있는 회사로, 고속 광 트랜시버 및
            부품의 연구 개발과 제조를 전문으로 하고 있습니다. Potron은 주로 다음과 같은 세 가지
            주요 응용 분야에서 차세대 AI 광통신 네트워크에 필수적인 제품을 제공합니다.
          </Lead>
        </Section>

        {/* 제품 라인업 */}
        <Section>
          <Eyebrow>Products</Eyebrow>
          <SectionTitle>고속 광통신 솔루션</SectionTitle>
          <CardRow>
            <ImageCard src={Portron1} alt="10G PON for FTTH Networks"
              caption={<>Revolutionizing Home Connectivity<br />10G PON for FTTH Networks</>} />
            <ImageCard src={Portron2} alt="25G CPRI for 5G"
              caption={<>25G CPRI Enabling 5G Wireless Communication</>} />
            <ImageCard src={Portron3} alt="High-Speed Data Center Solutions"
              caption={<>High-Speed Data Solutions for Data Centers<br />100G, 200G, 400G</>} />
          </CardRow>

          <SubTitle>Potron 연구 개발팀</SubTitle>
          <BodyText>
            Potron의 연구 개발 팀은 20년 이상의 경험을 바탕으로 고속 광 트랜시버 및 구성 요소를
            설계하고 개발하는 데 전념하고 있습니다. 이러한 오랜 경험과 전문성 덕분에 Potron은
            업계에서 최고 수준의 데이터 속도인 최대 400Gb/s를 달성했으며, 최대 120km의 전송
            거리를 자랑하는 제품을 제공합니다. Potron의 기술적 역량은 단순히 제품 성능에 그치지
            않고, 고객의 다양한 요구 사항을 충족시키기 위한 빠르고 유연한 대응력으로도 입증되고
            있습니다.
          </BodyText>
          <BodyText>
            이러한 강력한 기술적 배경과 고객 중심의 접근 방식을 통해 Potron은 고객으로부터 높은
            신뢰와 인정을 받고 있으며, 고객과의 협력을 통해 부가가치가 높은 고급 제품을 공동으로
            개발하고 있습니다. Potron은 지속적인 혁신과 품질 향상을 통해 광통신 산업의 발전에
            기여하고 있으며, 글로벌 시장에서 경쟁력을 유지하고 확대해 나가고 있습니다.
          </BodyText>

          <div style={{ height: 20 }} />
          <CardRow>
            <ImageCard src={Potron01} alt="Telecom / Datacom Transceiver"
              caption={<>Telecom / Datacom Transceiver<br />5G Wireless / Legacy series</>} />
            <ImageCard src={Potron02} alt="PON Transceiver Series"
              caption={<>PON Transceiver Series</>} />
            <ImageCard src={Potron03} alt="Data Center Transceiver Series"
              caption={<>Data Center Transceiver Series</>} />
          </CardRow>
        </Section>
      </Main>

      <VendorCta title="Potron 제품 문의 · 기술 상담" />
    </Page>
  )
}

export default Potron
